import { useEffect } from 'react';
import { VStack } from '@cbhq/cds-web/layout';
import { Text } from '@cbhq/cds-web/typography/Text';
import { ActionType, ComponentType, logEvent } from '@cbhq/client-analytics';
import { defineMessages, useIntl } from '@cbhq/i18n';

const messages = defineMessages({
  title: {
    id: 'Approvals.home.title',
    defaultMessage: 'Approvals',
    description: 'Title for the workspace Approvals page',
  },
});

export function ApprovalsPage() {
  const { formatMessage } = useIntl();

  useEffect(() => {
    logEvent('approvals_page_viewed', {
      componentType: ComponentType.page,
      action: ActionType.view,
    });
  }, []);

  return (
    <VStack className="workspaceContentFadeIn" gap={4} width="100%" data-testid="approvals-page">
      <Text as="h1" font="title1">
        {formatMessage(messages.title)}
      </Text>
    </VStack>
  );
}
